module.exports = require("google-protobuf");